<template>
	<div class="card">
		<div class="card-body">
			<div class="form-group">
				<label for="new-content">Content <span class="text-danger font-weight-bold">*</span></label>
				<textarea v-model="formData.content" class="form-control" id="new-content"></textarea>
				<validation-feedback v-if="errors.content" :errors="errors.content" />				
			</div>

			<div class="form-group">
				<label for="new-user_id">User <span class="text-danger font-weight-bold">*</span></label>
				<select v-model="formData.user_id" id="new-user_id" class="form-control">
					<option v-for="user in computedUsers" :value="user.id" :key="user.id">
						{{ user.name }}
					</option>
				</select>
				<validation-feedback v-if="errors.user_id" :errors="errors.user_id" />
			</div>

			<div class="form-group">
				<label>Type <span class="text-danger font-weight-bold">*</span></label>
				<select v-model="formData.note_type_id" id="new-user_id" class="form-control">
					<option v-for="type in [{id: 1, name: 'Info'}, {id: 2, name: 'Alert'}]" :value="type.id" :key="type.id">
						{{ type.name }}
					</option>
				</select>
				<validation-feedback v-if="errors.note_type_id" :errors="errors.note_type_id" />
			</div>
		</div>
		<div class="card-footer">
			<button type="button" @click="hideForm" class="btn btn-default">Cancel</button>
			<button type="button" @click="save" class="btn btn-primary">Save</button>
		</div>
	</div>
</template>

<script> 
import ValidationFeedback from '../shared/ValidationFeedback'
import { mapState } from 'vuex'
export default {
	name: "Note Form",
	components: {
		ValidationFeedback
	},
	data() {
		return {
			formData: {
				id: null,
				content: null,
				user_id: null, 
				note_type_id: null
			}	
		}
	},
	methods: {
		hideForm() {
			this.$store.dispatch('notes/closeForm')
		},
		save() {
			let data = {
				...this.formData,
				participant_id: this.participant.id
			}
			this.$store.dispatch('notes/saveNote', data)
		},
		setFormData() {
            if (!_.isEmpty(this.note)) {
                this.formData = {
                    id: this.note.id,
                    user_id: this.note.user_id,
                    note_type_id: this.note.note_type_id,
                    content: this.note.content
                }
        
            }
    	},
	},
	computed: {
        ...mapState({
            errors: state => state.notes.errors,
            note: state => state.notes.noteInForm,
            participant: state => state.notes.participant,
            users: state => state.notes.users
        }),
        computedUsers() {
        	return this.users.sort(function(a, b) {
				const firstNameComparison = a.first_name.localeCompare(b.first_name);
				return b.is_active - a.is_active || firstNameComparison;
			})
			.map(function (user) {
				let userStatus = user.is_active ? '' : '(inactive)';
				return {
					id: user.id,
					name: user.first_name+' '+user.last_name+' '+userStatus,
				};
			});
        }
    },
    mounted() {
        this.setFormData()
    }
}
</script>